import React from "react";
import { Modal, Typography } from "components";
import { IoMdClose } from "react-icons/io";
import { formatDateTimeExact, capitalizeFirstLetter } from "utils/helper";
import userAvatar from "assets/images/user-avatar.png";

const DetailModal = ({ open, onClose, detail }) => {
  const { subject, recipientAddress, message, dateCreated, user } = detail || {};
  return (
    <Modal showModal={open} onClose={onClose}>
      <div className="row py-4">
        <div className="d-flex justify-content-end">
          <IoMdClose className="cursor-pointer" onClick={onClose} />
        </div>

        <Typography variant="subtitle3" state="primary">
          Email Subject: {subject}
        </Typography>
        <Typography className="py-4" variant="body3">
          {message}
        </Typography>
        <div className="mt-4 d-flex align-items-center justify-content-between">
          <div className="d-flex">
            <img src={userAvatar} alt={""} height="45px" />
            &nbsp;
            <div className="mx-2 d-lg-block">
              <Typography variant="body3">
                {capitalizeFirstLetter(user?.firstName) +
                  " " +
                  capitalizeFirstLetter(user?.lastName)}
              </Typography>
              <Typography variant="body4">{recipientAddress}</Typography>
            </div>
          </div>

          <Typography state="grey" variant="caption1">
            {formatDateTimeExact(dateCreated)}
          </Typography>
        </div>
      </div>
    </Modal>
  );
};

export default DetailModal;
